import { render } from "./CrossSvg.vue?vue&type=template&id=4d1d8432"
import script from "./CrossSvg.vue?vue&type=script&lang=js"
export * from "./CrossSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__